(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/components/play/assets/javascripts/views/single-rows-container.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/components/play/assets/javascripts/views/single-rows-container.js');

'use strict';

svs.vikinglotto.components.play.views.SingleRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content grid-row padding-xs-h-1 padding-xs-bottom-2 padding-sm-h-1 padding-md-bottom-0 padding-md-h-2',
  regions: {
    boardContainerRegion: '#boardContainerRegion',
    rowsRegion: '#rowsRegion'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.core.behaviors.BindViewRadio,
    channel: svs.numbergames.game.huxfluxRadio
  }],
  onAttach() {
    var _this$model$get;
    const firstBoard = (_this$model$get = this.model.get('boards')) === null || _this$model$get === void 0 ? void 0 : _this$model$get.first();
    if (firstBoard !== null && firstBoard !== void 0 && firstBoard.get('isEmpty') && firstBoard !== null && firstBoard !== void 0 && firstBoard.get('isInitialState')) {
      setTimeout(() => {
        this.radio.trigger('huxflux:start', firstBoard);
        firstBoard.set('isInitialState', false);
      }, 1500); 
    }
  },
  template(data) {
    return svs.vikinglotto.components.play.templates.single_rows_container(data);
  },
  onRender() {
    this.showChildView('boardContainerRegion', new svs.numbergames.game.views.BoardContainer({
      model: this.model
    }));
    this.showChildView('rowsRegion', new svs.numbergames.game.views.SingleRowsContainer({
      model: this.model
    }));
  }
});

 })(window);